import { render, staticRenderFns } from "./InvoiceAlbum.vue?vue&type=template&id=6f89fdd9&scoped=true"
import script from "./InvoiceAlbum.vue?vue&type=script&lang=js"
export * from "./InvoiceAlbum.vue?vue&type=script&lang=js"
import style0 from "./InvoiceAlbum.vue?vue&type=style&index=0&id=6f89fdd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f89fdd9",
  null
  
)

export default component.exports